



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { SIPTrunkNumber } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService, userService } from '@/shared';
import { Utils } from '@/helper/utils';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveSipTrunk extends Base {
  public phoneMask: string = '##########';
  public SIPTrunkDetailsFields: Array<VFields<any>> = [];
  public SIPTrunkNumbersModel: SIPTrunkNumber = {
    id: '',
    name: '',
    trunkId: '',
  };

  public storeId: number = 0;
  public form: any = {};
  public sipTrunkDetailId: string = '';

  public requestProgress: boolean = false;
  public userList: any[] = [];

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'SIPTrunkDetails' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.saveTrunkDetails();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.storeId = Number(this.$route.params.storeId);
    if (this.$route.params.trunkDeatilId) {
      this.sipTrunkDetailId = this.$route.params.trunkDeatilId;
    }

    this.setSIPTrunkDetailsFields();
    if (this.$route.params.storeId) {
      this.getStoreInfo();
    }

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public setSIPTrunkDetailsFields(): void {
    this.SIPTrunkDetailsFields = [
      {
        key: 'name',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Name',
          loading: false,
          rules:[
            v => this.required('Name', v)
          ]
        },
      },
      {
        key: 'trunkId',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Trunk Id',
          loading: false,
          rules:[
            v => this.required('Trunk Id', v)
          ]
        },
      },
    ];
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.SIPTrunkDetailsFields);
      const response = await storeService.getStore(this.storeId);
      const selectedForwardingNumber = response.storeJson.sipTrunkDetails.find(
        (m) => m.id === this.$route.params.trunkDeatilId
      );

      if (this.sipTrunkDetailId) {
        this.SIPTrunkNumbersModel.id = selectedForwardingNumber.id;
        this.SIPTrunkNumbersModel.name = selectedForwardingNumber.name;
        this.SIPTrunkNumbersModel.trunkId = selectedForwardingNumber.trunkId;
      }
    } finally {
      this.formlyHideSkeleton(this.SIPTrunkDetailsFields);
    }
  }

  // public async getUsers(): Promise<void> {
  //   try {
  //     this.formlyShowSkeleton(this.faxLineFields, 'assignedUsers');
  //     const response = await userService.getStoreUsersListAsync();
  //     this.userList = response.results;
  //     this.setFaxFields();
  //   } finally {
  //     this.formlyHideSkeleton(this.faxLineFields, 'assignedUsers');
  //   }
  // }

  public validateTrunkDetails(): Vue & { validate: () => boolean } {
    return this.$refs.trunkDetailForm as Vue & { validate: () => boolean };
  }

  public async saveTrunkDetails(): Promise<void> {
    if(this.validateTrunkDetails().validate()){
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        if (this.SIPTrunkNumbersModel.id === '') {
          await storeService.saveSIPTrunkDetails(this.storeId,this.SIPTrunkNumbersModel);
          this.showAlert(true, 'SIP Trunk Details Added successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params:{
                tab:'SIPTrunkDetails'
              }
            })
            .catch((ex) => {
              console.log(ex);
            });
        } else {
          await storeService.updateSIPTrunkDetails(this.storeId,this.SIPTrunkNumbersModel);
          this.showAlert(true, 'SIP Trunk Details Updated successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                storeId: this.storeId.toString(),
                tab:'SIPTrunkDetails'
              },
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
}
